import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";

export default function GoodProductTable() {
  return (
    <table className="KPIs-table">
      <tr>
        <th>Strategic Imperative</th>
        <th>KPI</th>
        <th>Unit</th>
        <th>Weight (%)</th>
        <th>
          <div>Target</div>
          <div>YTD</div>
        </th>
        <th>
          <div>Actual</div>
          <div>YTD</div>
        </th>
        <th>%Achieved</th>
        <th>Score</th>
        <th>
          <div>Actual</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Feb</div>
        </th>
        <th>
          <div>Mar</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Apr</div>
        </th>
        <th>
          <div>Actual</div>
          <div>May</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jun</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jul</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Aug</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Sep</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Oct</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Nov</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Dec</div>
        </th>
      </tr>
      <tr className="table-collapse">
        <td style={{ border: "none", background: "#bffe67", whiteSpace: 'nowrap' }}>สินค้าดี ราคาคุ้มค่า</td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
        <td style={{ border: "none", background: "#bffe67" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>สินค้ารูปแบบเดิม (Existing Product) : Better</td>
        <td>%เติบโตของยอดขายสินค้า ในรูปแบบเดิม กลุ่ม Better</td>
        <td>%</td>
        <td>3.0%</td>
        <td>12%</td>
        <td>22%</td>
        <td>181%</td>
        <td>5</td>
        <td></td>
        <td></td>
        <td>8%</td>
        <td></td>
        <td></td>
        <td>24%</td>
        <td></td>
        <td></td>
        <td>23%</td>
        <td></td>
        <td></td>
        <td>34%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>สินค้ารูปแบบเดิม (Existing Product) : Good</td>
        <td>%เติบโตของยอดขายสินค้า ในรูปแบบเดิม กลุ่ม Good</td>
        <td>%</td>
        <td>2.0%</td>
        <td>14%</td>
        <td>(9%)</td>
        <td>64%</td>
        <td>1</td>
        <td></td>
        <td></td>
        <td>(10%)</td>
        <td></td>
        <td></td>
        <td>(9%)</td>
        <td></td>
        <td></td>
        <td>(21%)</td>
        <td></td>
        <td></td>
        <td>(10%)</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>พัฒนาสินค้าใหม่รูปแบบเดิม (NPD)</td>
        <td>สัดส่วนยอดขาย NPD</td>
        <td>%</td>
        <td>2.0%</td>
        <td>3%</td>
        <td>3%</td>
        <td>103%</td>
        <td>4</td>
        <td></td>
        <td></td>
        <td>3%</td>
        <td></td>
        <td></td>
        <td>3%</td>
        <td></td>
        <td></td>
        <td>3%</td>
        <td></td>
        <td></td>
        <td>3%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>พัฒนาสินค้าใหม่รูปแบบใหม่ (New Cat)</td>
        <td>สัดส่วนยอดขาย New Cat</td>
        <td>%</td>
        <td>3.0%</td>
        <td>9%</td>
        <td>7%</td>
        <td>80.4%</td>
        <td>3</td>
        <td></td>
        <td></td>
        <td>7%</td>
        <td></td>
        <td></td>
        <td>7%</td>
        <td></td>
        <td></td>
        <td>7%</td>
        <td></td>
        <td></td>
        <td>8%</td>
      </tr>
    </table>
  );
}
